var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 41,
    viewBox: "0 0 66 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0002 5.23083C28.4125 8.8641 25.4722 14.4843 25.4722 20.7984C25.4722 27.1126 28.4125 32.7328 33.0002 36.3661C37.5878 32.7328 40.5281 27.1126 40.5281 20.7984C40.5281 14.4843 37.5878 8.8641 33.0002 5.23083Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Left",
    d: "M31.4125 37.5103C26.6289 33.5272 23.5829 27.5209 23.5829 20.7986C23.5829 14.0763 26.6289 8.06999 31.4124 4.08695C28.3364 2.111 24.675 0.953125 20.7342 0.953125C9.76402 0.953125 0.888672 9.82847 0.888672 20.7986C0.888672 31.7688 9.76402 40.6441 20.7342 40.6441C24.675 40.6441 28.3364 39.4862 31.4125 37.5103Z",
    fill: "#C8283B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M45.2667 40.6441C56.2369 40.6441 65.1122 31.7688 65.1122 20.7986C65.1122 9.88359 56.2369 0.953125 45.2667 0.953125C41.3259 0.953125 37.6645 2.11101 34.5884 4.08696C39.3719 8.07 42.4179 14.0763 42.4179 20.7986C42.4179 27.5209 39.3719 33.5272 34.5884 37.5103C37.6645 39.4862 41.3258 40.6441 45.2667 40.6441Z",
    fill: "#C8283B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.7c56ad7c18afbbcf88d8b6a740c6f889.svg";
export { ForwardRef as ReactComponent };